let settings;

if (!!process.env.DOMAIN) {
    settings = require(`./settings.${process.env.DOMAIN}`);
} else {
    const env = require('./env');
    if (!!env) {
        settings = require(`./settings.${env.domain}`);
    }
}

if (!settings) {
    settings = require('./settings.SO');
}

export default settings.default;



// WEBPACK FOOTER //
// ./config/settings.js